export const buildExactCampaignLaunchOutbox = ({
  source,
  actionType,
  ...payload
}) => {
  if (!source) {
    throw new Error('Campaign launch outbox requires source');
  }
  if (!actionType) {
    throw new Error('Campaign launch outbox requires actionType');
  }

  return {
    ...payload,
    source,
    actionType,
    scriptSelectionMode: 'exact'
  };
};
